<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="container-fluid my-3">

    <div class="filter my-3">
      <div class="filter-head">
        <h4>رسائل الحجز — {{ group?.name ?? '...' }}</h4>
        <div class="buttons">
          <router-link :to="`/grades/${gradeSlug}/groups/${groupId}`" class="btn btn-outline-primary">
            <i class="pi pi-arrow-right me-1"></i> رجوع لطلاب المجموعة
          </router-link>
        </div>
      </div>
      <p class="text-muted mb-0">اترك أي حقل فارغاً لاستخدام النص الافتراضي من "نصوص الموقع"</p>
    </div>

    <div v-if="loading" class="text-center py-5">
      <i class="pi pi-spin pi-spinner" style="font-size:1.5rem;"></i>
    </div>

    <form v-else @submit.prevent="save">
      <div class="row g-4">
        <div class="col-md-6 col-12">
          <div class="form-field">
            <label class="field-label">رسالة قبول الطالب</label>
            <Editor v-model="messages.accept_message" editorStyle="height: 180px" />
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="form-field">
            <label class="field-label">رسالة رفض الطالب</label>
            <Editor v-model="messages.reject_message" editorStyle="height: 180px" />
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="form-field">
            <label class="field-label">رسالة الطالب معلق</label>
            <Editor v-model="messages.waiting_message" editorStyle="height: 180px" />
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="form-field">
            <label class="field-label">الرسالة بعد إرسال الطلب</label>
            <Editor v-model="messages.after_submit_message" editorStyle="height: 180px" />
          </div>
        </div>
      </div>

      <div class="mt-3 text-end">
        <button type="submit" class="btn PrimaryButton" :disabled="saving">
          <i class="pi pi-spin pi-spinner-dotted" v-if="saving"></i>
          {{ saving ? 'جاري الحفظ...' : 'حفظ الرسائل' }}
        </button>
      </div>
    </form>

  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import Editor from 'primevue/editor';
import Breadcrumb from '@/components/global/breadcrumb.vue';

export default {
  name: 'GradeGroupMessages',
  components: { Editor, Breadcrumb },

  data() {
    return {
      group: null,
      loading: true,
      saving: false,
      messages: {
        accept_message: '',
        reject_message: '',
        waiting_message: '',
        after_submit_message: '',
      },
    };
  },

  computed: {
    gradeSlug() { return this.$route.params.gradeSlug; },
    groupId() { return this.$route.params.groupId; },
    breadcrumbs() {
      return [
        { name: 'الرئيسية', path: '/' },
        { name: 'مجموعات الطلاب', path: `/grades/${this.gradeSlug}/groups` },
        { name: this.group?.name ?? 'المجموعة', path: `/grades/${this.gradeSlug}/groups/${this.groupId}` },
        { name: 'رسائل الحجز', path: `/grades/${this.gradeSlug}/groups/${this.groupId}/messages` },
      ];
    },
  },

  methods: {
    async fetchGroup() {
      this.loading = true;
      try {
        const { data } = await axios.get(`/groups/${this.groupId}`);
        this.group = data.data;
        this.messages = {
          accept_message: this.group?.accept_message ?? '',
          reject_message: this.group?.reject_message ?? '',
          waiting_message: this.group?.waiting_message ?? '',
          after_submit_message: this.group?.after_submit_message ?? '',
        };
      } finally {
        this.loading = false;
      }
    },

    async save() {
      this.saving = true;
      try {
        const { data } = await axios.put(`/groups/${this.groupId}`, {
          name: this.group.name,
          ...this.messages,
        });
        this.group = data.data;
        Swal.fire('', 'تم حفظ رسائل الحجز بنجاح', 'success');
      } catch (error) {
        Swal.fire('', error.response?.data?.message || 'حدث خطأ أثناء الحفظ', 'error');
      } finally {
        this.saving = false;
      }
    },
  },

  mounted() {
    this.fetchGroup();
  },
};
</script>

<style scoped>
</style>
